import { render, staticRenderFns } from "./summery.vue?vue&type=template&id=49d838cf&"
import script from "./summery.vue?vue&type=script&lang=js&"
export * from "./summery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports